import { Role } from '../../../../../common/constants/role';
import { UserRoleType } from '../constants/user-roles.constant';

export type UserRolesModel = Record<UserRoleType, Role[]>;

export type UserRolesGroupType = { key: UserRoleType; value: Role[] };
